import React, { Component } from 'react';
import { Col } from 'react-bootstrap';
import { highlightColumnColor } from '../../utils/dashboardCalculations';

class teamCard extends Component {
	componentDidMount() {}

	render() {
		const { player, userAllowed, sportsID } = this.props;
		// const highlightColor = highlightColumnColor(player.team_gaming_score, 'cardHighlight',);
		const highlightColor = highlightColumnColor(player?.gaming_score, 'cardSpread', 'playerhealth', true)
		console.log(highlightColor,'highlightColor')
		return (
			<div id='cardTeamRow' className='cardTeamRow'>
				<Col lg={12} className={`cardHighlight  ${userAllowed && highlightColor} cardAdminTeamCol col-xs-12`}>
					<img
						src={
							player.thumb_url
								? player.thumb_url
								: (!player.team_logo || player.team_logo === 'null'
									? player.team_logo_secondary
									: player.team_logo)
						}
						alt={`${player.team_name || ''} logo`}
						className="cardTeamLogo"
					/>
					<div className='cardTeamDiv'>
					<p className='cardTeamName'>
						{player.player_name} ({player.position})
						<br></br>
						<br></br>
						{player.jersey}
					</p>
					</div>
				</Col>
			</div>

		);
	}
}

export default teamCard;
